import { render } from "./customSelect.vue?vue&type=template&id=6b4fe156"
import script from "./customSelect.vue?vue&type=script&lang=js"
export * from "./customSelect.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__